import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { TechsToolsManagementComponent } from './techs-tools-management/techs-tools-management.component';
import { ManageTechsDialogComponent } from './manage-techs-dialog/manage-techs-dialog.component';
import { ManageToolsDialogComponent } from './manage-tools-dialog/manage-tools-dialog.component';



@NgModule({
  declarations: [
    TechsToolsManagementComponent,
    ManageTechsDialogComponent,
    ManageToolsDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatStepperModule,
    MatSnackBarModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatDialogModule,
    MatCheckboxModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    RouterModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    FlexLayoutModule,
    MatPaginatorModule,
    NgxMatSelectSearchModule
  ]
})
export class TechsToolsManagementModule { }
